export type BadgeSizeSlug = 's' | 'm' | 'l';

export class BadgeSize {
  public static SIZE_S: BadgeSizeSlug = 's';
  public static SIZE_M: BadgeSizeSlug = 'm';
  public static SIZE_L: BadgeSizeSlug = 'l';
}
